import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

const VisualhygieneText = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      pt: 6
    }}
    {...props}
  >
    <Container
      maxWidth="md"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        px: {
          md: '130px !important'
        }
      }}
    >
      <Typography
        color="textSecondary"
        sx={{ mb: 2 }}
        variant="body1"
        align="justify"
      >
        <h3>Visualhygiene</h3>
        <h4>Was ist Visualhygiene?</h4>
        Visualhygiene ist als Konzept noch kaum bekannt. Wie sehr unsere Augen bei der Ausführung des Sehens durch schlechte oder unangemessene Gewohnheiten leiden können, ist den meisten Menschen gar nicht bewusst. Gesundheitsbewusster Umgang mit Sehen, Denken, Handeln gehört für uns genauso dazu wie verantwortungsvoll durchgeführtes ViCo Training, weshalb wir auch in diesem Bereich gerne mit eyerena Aufklärungsarbeit leisten möchten. Viel Naharbeit, exzessive Nutzung digitaler Medien und der damit oft einhergehende Bewegungsmangel können zu Augenproblemen führen. Man spricht hier auch von asthenopischen Beschwerden.
        <br />
        <br />
        <h4>Was sind asthenopische Beschwerden?</h4>
        <ul>
          <li>Trockene Augen, tränende Augen, brennende Augen, Fremdkörpergefühl</li>
          <li>Reibegefühl</li>
          <li>Druckgefühl</li>
          <li>Verschwommensehen</li>
          <li>Schulter- und Nackenschmerzen bzw. Verspannungen</li>
          <li>Lichtempfindlichkeit</li>
          <li>Kopfschmerzen bis hin zur Migräne</li>
          <li>Starke Ermüdung bis hin zur Erschöpfung</li>
          <li>Konzentrationsschwäche</li>
          <li>geringe Aufmerksamkeitsspanne</li>
          <li>Augenrötungen</li>
          <li>Doppelbilder</li>
          <li>Schwindel</li>
        </ul>
        <br />
        <h4>Wie entstehen Beschwerden und wie hilft Visualhygiene?</h4>
        <h4>Warum und Nutzen</h4>
        Wir möchten unsere Augenfunktionen auf höchstem Niveau bei minimalem Energieaufwand nutzen.
        Die Anwendung einer korrekten Visualhygiene ermöglicht uns dies und erzielt positive Resultate in folgenden Sehaspekten:
        <ul>
          <li>Gesteigerter Sehkomfort bei Schreib- und Lesearbeiten,</li>
          <li>Gesteigerte Leistungsfähigkeit des visuellen Systems,</li>
          <li>Vermeidung von funktionalen Sehstörungen z.B. Myopisierung (Steigerung der Kurzsichtigkeit).</li>
        </ul>
        <br />
        <h4>Beschwerden entstehen</h4>
        Naharbeit am PC oder an anderen digitalen Geräten ist für das visuelle System anstrengend. Es kommt durch sie häufig zu einem Konvergenzexzess, der wiederum eine Über-Akkommodation nach sich zieht. Das visuelle System kompensiert nicht die Tendenz zur Unschärfe am Bildschirm, hervorgerufen durch diese Über-Akkommodation und/oder näher liegende Konvergenz. Das Verhältnis von Vergenz und Akkommodation wird unharmonisch, die Folgen: Stress und Spannungsgefühle.
        <br />
        Unsere Pupille vergrößert sich bei unzureichender Beleuchtung, aber auch bei Stress.  Lichtempfindlichkeit motiviert wiederum oft eine weitere Reduzierung von Lichtquellen. Unter Stress reduziert sich zudem die Lidschlagfrequenz. In der Folge leiden wir dadurch unter trockenen, tränenden und brennenden Augen,  haben mit Druck-, Reibe- oder Fremdkörpergefühl zu kämpfen, bekannt als SICCA Syndrom.
        <br />
        <br />
        Verspannungen bzw. Verkrampfungen der Augenmuskulatur und mangelnde Bewegung sorgen unweigerlich auch für solche im Bereich von Schultern und Nacken. Wird der Sehstress zu groß, reagiert unser Körper mit Kopfschmerzen und/oder Migräne.
        <br />
        <br />
        <h4>Tipps für Betroffene</h4>
        Verstehe die Kopfschmerzen als Hilferuf Deines Körpers und Deines Gehirns. Der Körper will Dir mitteilen, dass dir diese Art von Sehen nicht guttut. Nimm keine Tablette, lege lieber eine Pause ein. Am besten, Du machst alles „richtig“ und vermeidest Sehstress, dann geht es Dir schnell besser und du bist deutlich ausgeruhter und leistungsfähiger.
        <br />
        <br />
        <br />
        <h4>Visualhygiene richtig praktizieren</h4>
        <h4>Ergonomie</h4>
        Wirksame Visualhygiene am PC beruht auf elementaren ergonomischen Aspekten.
        <br />
        <br />
        Sich der korrekten Körperhaltung bewusst sein und sie ggf. zu korrigieren. Mit Oberarm und Unterarm  einen rechten Winkel bilden, genauso wie mit dem Oberkörper und Oberschenkel sowie Oberschenkel und Unterschenkel. Deine Füße sollten mit der ganzen Fußfläche auf dem Boden stehen können. Ein zu hoher Tisch, der keinen rechten Winkel zwischen Ober- und Unterarm ermöglicht, zwingt zu einer kurzen Arbeitsdistanz. Die anstrengende Naharbeit wird hierdurch unnötigerweise noch anstrengender. Verwende idealerweise stattdessen einen schrägen Arbeitstisch mit einer Neigung von 20 Grad. Dies bringt den Blickeinfallswinkel auf zirka 90 Grad zur Blickebene.
        <br />
        <br />
        Halte stets die korrekte Arbeitsdistanz und Haltung zum Bildschirm ein. Wenn Du am PC sitzt, strecke den Arm aus, die Finger sollten dann den Bildschirm berühren. Je größer der Bildschirm, desto größer der Abstand.
        <br />
        <br />
        Der Monitor sollte unterhalb der Augenhöhe liegen. Nutzt du einen Laptop, besorge dir unbedingt  externe Tastatur und Monitor, sonst sind Augen- und Schulter-Nackenprobleme vorprogrammiert.
        <br />
        <br />
        Lege die Tastatur ungefähr 10 cm von der Tischkante entfernt, sodass die Handgelenke gut aufliegen und so maximale Entlastung für die Schultern geben.
        <br />
        <br />
        Sorge für gutes Licht, bevorzuge Vollspektrum Tageslicht.
        <br />
        <br />
        <br />
        <h4>Weitere Tipps und präventive Maßnahmen</h4>
        <h4>Richtiger Leseabstand</h4>
        Die Distanz vom Ellbogen bis zur Faust bezeichnet man als Harmonabstand. Sie ist die geeignete Entfernung, um eine korrekte Akkommodation beizubehalten, ohne das visuelle System hierbei einer Überanstrengung auszusetzen.
        <h4>Kurze Pausen einlegen</h4>
        Langanhaltende Naharbeit stimuliert das sympathische Nervensystem. Diese Stimulation gepaart mit Bewegungsmangel hat den ausgesprochen negativen Nahstress zur Folge. Man hat erkannt, dass selbst kurze Zeiträume exzessiver Naharbeit zu Akkommodationskrämpfen führen können. Diese Verkrampfung des Ziliarmuskels macht sich z.B. durch verschwommenes Sehen in der Ferne bemerkbar.
        <br />
        <br />
        Wenn Du Stress hast, bleibe nicht sitzen, sondern stehe für ein paar Minuten auf, laufe herum und bewege Deinen Körper – so werden die Stresshormone schneller abgebaut und Du kannst entspannter weiterarbeiten.
        <h4>20-20-20</h4>
        Alle 20 Minuten solltest Du für 20 Sekunden in die Ferne schauen, sprich 20 Meter. Alleine den Blick zu heben und aus dem Fenster zu schauen, reicht oft jedoch nicht aus, um eine Verkrampfung zu lösen. Wenn Du also aus dem Fenster schaust, stehe zuerst auf (Bewegung!) und zähle dann 20-30 Blätter in der Ferne an einem Baum. Wenn Du dies 3-4-mal am Tag beherzigst, nimmt die Gefahr, dass es zu einer Muskelverkrampfung kommt, rapide ab.
        <br />
        <br />
        <br />
        <h4>Noch mehr Tipps</h4>
        <h4>Bildschirmzeiten beschränken</h4>
        Wenn Du krank oder müde bist, schränke Deine Lektüre oder Naharbeit ein.
        Versuche, die Zeit am Smartphone, Tablet oder TV zumindest ab und an zu reduzieren.
        <br />
        <br />
        Achte bei der Nutzung auf jeden Fall aber auf die korrekte Entfernung vom Bildschirm und beleuchte die Peripherie des Raumes angemessen.
        <h4>Bewegung</h4>
        Treibe regelmäßig Sport, gehe nach draußen, genieße Wanderungen, Natur und Waldgänge.
        <h4>Palmieren</h4>
        Schließe zwischendurch die Augen und schaffe Dir ein imaginäres Bild. Die Übung Palmieren ist ein wahres Entspannungswunder. Reibe hierzu Deine Hände aneinander, bis die Handinnenfläche warm sind. Führe sie darauf über Deine Augen und schließe diese für einen Moment. Genieße das Gefühl der Wärme und atme ruhig und tief in den Bauch. Voriges Gähnen und Ausschütteln des gesamten Körpers empfiehlt sich, die Augen sollen sich komplett ausruhen können. Lockere Schulter und Körperhaltung, keine Kreuzung der Glieder. Die Handwurzel der jeweiligen Hand liegt schräg auf dem entsprechenden Backenknochen, sodass beide Handinnenfläche wie eine kleine Schüssel über dem Auge liegen und die Finger etwas schräg und entspannt auf der Stirn ruhen.
        <br />
        <br />
        <br />
        <h4>Tipps für Brillenträger</h4>
        Verwende Deine Fernkorrektur nicht bei allen Tätigkeiten, mache auch zwischendurch einmal die Erfahrung, wie es ist, ohne Brille in die Ferne zu sehen und interpretiere das, was Du wahrnehmen kannst. Du wirst überrascht sein, was alles „sichtbar“ wird, wenn Du es zulässt. Eine Unterkorrektur Deiner Kurzsichtigkeitsbrille am PC ist oft auch eine gute Möglichkeit, Sehstress (Akkommodationsstress) zu verringern. Dies gilt im Besonderen für Kinder.
        <br />
        <br />
        Übertreibe es nicht mit Zucker und Süßigkeiten, denn dies kann ein Längenwachstum des Auges begünstigen und so die Zunahme von Kurzsichtigkeit befeuern.
        <br />
        <br />
      </Typography>
    </Container>
  </Box>
);
export default VisualhygieneText;
